import React from "react"
import { useSkeem } from "../../providers/SkeemProvider"
import { useHistory, useLocation } from "react-router-dom"
import { useAsyncEffect } from "../../hooks/useAsyncEffect"
import { SplashScreen } from "../../interfaceParts/SplashScreen"
import { Helmet } from "@cd2/components/build/es6"
import { errorIs } from "@cd2/error-box"

export function LogoutPage() {
  const skeem = useSkeem()
  const history = useHistory()
  const location = useLocation()

  useAsyncEffect(async () => {
    try {
      await skeem.logout()
    } catch (e) {
      const islogoutNotAuthenticated = errorIs(e, "skeem.sessions.logoutNotAuthenticated")
      if (!islogoutNotAuthenticated) {
        console.error(e)
      }
    }

    const returnTo =
      new URLSearchParams(location.search).get("returnTo") ||
      (location.state as { returnTo?: string } | undefined)?.returnTo

    history.replace(returnTo || "/")

    if (navigator.credentials && navigator.credentials.preventSilentAccess) {
      navigator.credentials.preventSilentAccess()
    }
  }, [])

  return (
    <React.Fragment>
      <Helmet title={`Logging you out... | CleverGoose`} />
      <SplashScreen alternativeText={"Logging you out..."} />
    </React.Fragment>
  )
}
